import moment from 'moment-business-days'

import {setBusinessDays} from '../../../../fields/dateTime/dateTime.utils'
import {DateTimeConfiguration, DateTimeForm} from '../../../../fields/dateTime/types'
import {CreateFormInput} from '../types'

export const buildDateTimeForm = ({
  order,
  configuration
}: CreateFormInput<DateTimeConfiguration>): DateTimeForm => {
  // TODO: move that to custom logic component
  const {
    dateTime: {businessDays, holidays}
  } = configuration

  const originalLocale = moment.locale()
  setBusinessDays(originalLocale, businessDays, holidays)

  const schedule = order.schedules[0]
  if (!schedule) {
    // this comes from order mapping in OnSite, we shouldn't fall to this case for real orders
    return {
      dateTime: [order.shippingDate ?? moment().toISOString()]
    }
  }

  return {
    dateTime: [
      schedule.scheduleStartDate ?? order.shippingDate ?? schedule.scheduleEarliestStartDate
    ]
  }
}
